<template>
    <div class="loading-spinner">
        <div class="spinner"></div>
    </div>
</template>

<script>
// https://stephanwagner.me/only-css-loading-spinner
export default {
name: "LoadingSpinner"
}
</script>

<style>
@keyframes loadingspinner {
  to {transform: rotate(360deg);}
}
 
.loading-spinner .spinner {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  margin-left: -20px;
  border-radius: 50%;
  border: 3px solid #ccc;
  border-top-color: #0480be;
  animation: loadingspinner 1s linear infinite;
}

.loading-spinner {
    height: 50px;
    position: relative;
}
</style>